/* global gtag */
/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      pure lib — the analytics «purchase» event of a confirmed shop order
 *              (gtag + GTM dataLayer), moved verbatim out of controllers/checkout.js
 *              checkoutTask.
 *   users:     controllers/checkout.js checkoutTask (inside its post-confirm try: a
 *              throw here is reported there and never touches the cart)
 *   gotchas:   both sinks are optional (ad blockers, consent): each is guarded.
 */

const lines = (list, category) =>
  (list || []).map((p) => ({
    item_id: p.id,
    item_name: p.name,
    item_category: category,
    price: p.price,
    quantity: p.quantity || 1,
  }));

/**
 * @param {string|number} paymentId the payment /ecommerce_confirm created
 * @param {object} data riepilogo.data of the confirmed order
 */
export function trackPurchase(paymentId, data) {
  if (typeof gtag === 'function') {
    gtag('event', 'purchase', {
      event_category: 'ecommerce',
      event_label: 'purchase',
      send_to: 'G-Q4R8QL4WC0',
    });
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: paymentId,
        value: data.prezzo_preno,
        items: [
          ...lines(data.groups, 'groups'),
          ...lines(data.private, 'private'),
          ...lines(data.voucher, 'voucher'),
        ],
      },
    });
  }
}
